const OWNERSHIP_DOCUMENT_CATEGORY_ID = 2;

export const convertDocumentKeys = (values = {}) => {
  const documentsValues = {};

  const { documents, proofOfOwnershipDescription } = values;

  documents?.forEach(
    (
      {
        file,
        documentURL,
        documentTypeId,
        id,
        parentId,
        documentCategoryId,
        imageFileSize,
        documentFileSize,
        utilities = [],
      },
      index
    ) => {
      const documentKey = file ? "file" : "documentURL";

      const document = {
        id,
        documentTypeId,
        parentId: parentId || "",
        documentCategoryId: documentCategoryId || "",
        [documentKey]: file || documentURL,
        imageFileSize,
        documentFileSize,
      };

      // adding document description and category id when document type is other
      if (documentTypeId === 0) {
        document.documentCategoryId = OWNERSHIP_DOCUMENT_CATEGORY_ID;
        document.description = proofOfOwnershipDescription || "";
      }

      Object.keys(document).forEach((key) => {
        documentsValues[`documents[${index}].${key}`] = document[key];
        utilities.forEach((utilityId, utilityIndex) => {
          documentsValues[`documents[${index}].utilities[${utilityIndex}]`] =
            utilityId;
        });
      });
    }
  );
  return { ...values, ...documentsValues };
};
